export default (width = 60, height = 60, color = '#309A02') => `
<svg width="${width}" height="${height}" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M30 60c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30z" fill="${color}"/>
    <path d="M18 30.349l8.715 8.42L42 24" stroke="#fff" stroke-width="2"/>
</svg>
`